import { createTheme, type ThemeOptions } from "@mui/material";

const customTheme = createTheme({
    palette: {
        mode: "dark",
        spacing: 5,
        primary: {
            darkest: '#324656',
            darker: '#4B88AD',
            dark: '#6D9ABC',
            main: '#A2CDED',
            light: '#91D0FF',
            lighter: '#D8EEFF'
        },
        secondary: {
            main: '#85683C',
            light: '#B9A77E',
            lighter: '#DCCBB2'
        },
        tertiary:{
            main: '#853C7F',
            light: '#BD6DB6'
        },
        neutral: {
            darkest: '#111213',
            darker: '#252829',
            dark: '#686661',
            main: '#B9B3AA',
            light: '#B9B3AA',
            lighter: '#FFFFFF'
        },
        accentInfo: {
            main: '#79A7FF' // autogenerated
        },
        accentSuccess: {
            main: '#79FF8B'
        },
        accentWarning: {
            main: '#85683C',
            light: '#DCCBB2' // autogenerated
        },
        accentError: {
            main: '#FF7979'
        },
    },
    typography: {
        // Use Satoshi as the preferred font; fall back to system fonts
        fontFamily: '"Satoshi-Variable", "Satoshi-Regular", "Segoe UI", "Segoe", system-ui, -apple-system, "Helvetica Neue", Arial, sans-serif',
        sizes: {
            xs: "0.75rem",
            sm: "0.875rem",
            md: "1rem",
            lg: "1.125rem",
            xl: "1.25rem",
            body: "16px",
            h1: "32px",
            h2: "24px",
            h3: "16px",
            h4: "16px",
            h5: "16px"
        },
        lineHeights:{
            h1: '36px',
            h2: '24px',
            h3: '20px',
            caption: '18px'
        },
        weights:{
            bolder: '700',
            bold: '500',
            regular: '400',
            thin: '200'
        }

    },
    shape: {
        border: {
            general: {
                radius: [
                    "none",
                    "1px",
                    "2px",
                    "3px",
                    "4px",
                    "5px",
                    "6px",
                    "7px",
                    "8px",
                    "16px"
                ],
                style: {
                    default: "solid"
                },
                width: [
                    "1px",
                    "2px",
                    "3px",
                    "4px"
                ],
                thickness: [
                    "0px",
                    "1px",
                    "1.5px",
                    "2px"
                ]
            },
            button: {
                radius: ['0px', '4px', '6px', '8px', '12px', '16px']
            }
        },
    },
    customShadows: [
        "none",
        "0px 1px 2px rgba(0,0,0,0.05)",
        "0px 2px 4px rgba(0,0,0,0.08)"
    ],
} as unknown as ThemeOptions);

export { customTheme };
